module.exports = __webpack_public_path__ + "img/BANNER_BA_PAG NUEVA.8da10376.png";